if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      if (!this.elements.button || !this.elements.panel || !this.elements.input) return;

      this.openSelector = this.openSelector.bind(this);
      this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
      this.onItemClick = this.onItemClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.elements.button.addEventListener('click', this.openSelector);
      this.addEventListener('keyup', this.onContainerKeyUp);
      document.addEventListener('click', this.onDocumentClick);

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick));
    }

    disconnectedCallback() {
      if (!this.elements.button || !this.elements.panel || !this.elements.input) return;

      this.elements.button.removeEventListener('click', this.openSelector);
      this.removeEventListener('keyup', this.onContainerKeyUp);
      document.removeEventListener('click', this.onDocumentClick);
      this.querySelectorAll('a').forEach((item) => item.removeEventListener('click', this.onItemClick));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.hidePanel();
    }

    closeOtherSelectors() {
      document.querySelectorAll('localization-form').forEach((element) => {
        if (element !== this && typeof element.hidePanel === 'function') element.hidePanel();
      });
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      this.hidePanel();
      if (this.elements.input.name === 'locale_code') {
        document.cookie = 'preferred_lang=' + this.elements.input.value + '; path=/; max-age=' + (365 * 24 * 60 * 60) + '; SameSite=Lax';
      }
      if (form) form.submit();
    }

    openSelector(event) {
      event.preventDefault();
      const isOpen = this.elements.button.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        this.hidePanel();
        return;
      }

      this.closeOtherSelectors();
      this.elements.button.focus();
      this.elements.panel.removeAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', 'true');
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
